import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPackageEdit: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconPackageEdit"><Path d="M11.5 20.5H3.5V3.5H8.5M8.5 3.5H15.5M8.5 3.5V9.5H15.5V3.5M15.5 3.5H20.5V10.5M14.5 18.1666V20.4999H16.8333L21.0833 16.2499C21.7277 15.6056 21.7277 14.5609 21.0833 13.9166C20.439 13.2723 19.3943 13.2723 18.75 13.9166L14.5 18.1666Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconPackageEdit;
